import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Menu, Icon, Responsive, Transition, Grid } from 'semantic-ui-react';
import MenuUsuario from "./MenuUsuario";
import { version } from "../../../package.json"

const VERSION = `v ${version}`;

const MenuHorizontal = props => {
  const [{ token, user }, condominio] = useSelector(state => [state.user, state.condominio.condominio]);

  const [visible, setVisible] = useState(false);

  const drawer = () => setVisible(p => !p);

  const getAutenticado = () => (
    <div style={styles.normalize}>
      <div>
        <Menu fixed='top' className="menu-horizontal" secondary style={styles.menu}>
          <Menu.Item position="left">
            <Link to="/">
              <span className="va-marca">
                <img src="/images/logo-voteassembleia-sem-escrita.png" alt="Vote Assembleia logo" className="va-marca-simbolo" />
                <span className="va-marca-nome"><b>VOTE</b>ASSEMBLEIA</span>
              </span>
            </Link>
            <Responsive minWidth={768}>
              <Link to="/perfil" className="va-topo-usuario" title="Preferências do usuário">
                <span className={`va-switcher-avatar ${user.logotipo && user.logotipo.url ? "com-logo" : ""}`}>
                  {user.logotipo && user.logotipo.url
                    ? <img src={user.logotipo.url} alt={user.nome} />
                    : (user.nome || "U").split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join("")}
                </span>
                <span className="va-switcher-texto">
                  <small>Administrador</small>
                  <b>{user.nome}</b>
                </span>
              </Link>
            </Responsive>
            <Responsive maxWidth={767}>
              {!!condominio && !!condominio.nome && <span style={styles.tituloLogo}>{condominio.nome}</span>}
            </Responsive>
          </Menu.Item>
          <Responsive as={Menu.Menu} minWidth={768} position='right' style={styles.menumenu}>
            {!!props.backLink && (
              <Menu.Item name="fale-conosco">
                <Link to={`${props.backLink}`} className="menu-link menu-item">
                  <Icon name="arrow left" /> Voltar
                </Link>
              </Menu.Item>
            )}
            {!!props.backFunction && (
              <Menu.Item name="fale-conosco">
                <span onClick={props.backFunction} className="menu-link menu-item">
                  <Icon name="arrow left" /> Voltar
                </span>
              </Menu.Item>
            )}
            <Menu.Item name="selecao-condominio">
              <Link id="selecao-condominio" to="/" className="menu-link menu-item">
                <Icon name="building" /> Condomínios<span className="va-menu-extra"> / Sociedades / Associações</span>
              </Link>
            </Menu.Item>
            <Menu.Item name="ajuda">
              <Link id="ajuda" to="/ajuda" className="menu-link menu-item">
                <Icon name="help circle" /> Ajuda
              </Link>
            </Menu.Item>
            <Menu.Item name="fale-conosco">
              <Link id="fale-conosco" to="/fale-conosco" className="menu-link menu-item">
                <Icon name="envelope" /> Fale Conosco
              </Link>
            </Menu.Item>
            <Menu.Item name="usuario">
              <MenuUsuario usuario={user} />
            </Menu.Item>
          </Responsive>
          <Responsive as={Menu.Menu} maxWidth={767} position='right' style={styles.menumenu}>
            <Menu.Item className="menu-item">
              <span className="menu-link-icone" onClick={drawer}>
                <Icon name={!visible ? "bars" : "close"} size="large" />
              </span>
            </Menu.Item>
          </Responsive>
        </Menu>
        <Transition duration={{ show: 400, hide: 250 }} animation="fade left" size='huge' visible={visible}>
          <div style={styles.drawer}>
            {!!condominio && !!condominio.nome && (
              <div className="text-center" style={styles.itemMenuInfo}>
                <Grid verticalAlign="middle" columns={2}>
                  <Grid.Column>
                    <h3>{condominio.unidades.length}</h3>
                    <p>Unidades</p>
                  </Grid.Column>
                  <Grid.Column style={{ textAlign: "left" }}>
                    <img src="/images/illustrations/unidades.svg" style={{ width: "80%", maxWidth: "120px", margin: "auto" }} alt="Unidades" />
                  </Grid.Column>
                </Grid>
              </div>
            )}
            <div>
              <Link id="perfil" to="/perfil" className="menu-link-drawer">
                <Icon name="user circle outline" /> Preferências do usuário
              </Link>
            </div>
            <div>
              <Link id="perfil" to="/" className="menu-link-drawer">
                <Icon name="home" /> Condomínios / Sociedades / Associações
              </Link>
            </div>
            {!!condominio && !!condominio.nome && (
              <>
                <div>
                  <Link id="perfil" to={`/condominios/${condominio._id}/unidades`} className="menu-link-drawer">
                    <Icon name="building" /> Unidades
                  </Link>
                </div>
                <div>
                  <Link id="perfil" to={`/condominios/${condominio._id}/responsaveis`} className="menu-link-drawer">
                    <Icon name="group" /> Proprietários
                  </Link>
                </div>
                <div>
                  <Link id="perfil" to={`/condominios/${condominio._id}/votacoes`} className="menu-link-drawer">
                    <Icon name="calendar check" /> Votações
                  </Link>
                </div>
                <div>
                  <Link id="notificacao" to={`/condominios/${condominio._id}/notificacoes`} className="menu-link-drawer">
                    <Icon name="alarm" /> Notificações
                  </Link>
                </div>
                <div>
                  <Link id="perfil" to={`/comprar`} className="menu-link-drawer">
                    <Icon name="credit card" /> Comprar Unidades Votantes
                  </Link>
                </div>
              </>
            )}
            <br />
            <div>
              <Link id="ajuda" to="/ajuda" className="menu-link-drawer">
                <Icon name="help circle" /> Ajuda
              </Link>
            </div>
            <div>
              <Link id="fale-conosco" to="/fale-conosco" className="menu-link-drawer">
                <Icon name="envelope" /> Fale Conosco
              </Link>
            </div>
            <div>
              <Link id="logout" to="/logout" className="menu-link-drawer">
                <Icon name="sign-out" /> Sair
              </Link>
            </div>
          </div>
        </Transition>
      </div>
      <Transition duration={{ show: 300, hide: 200 }} animation="fade" size='huge' visible={visible}>
        <div style={styles.bgDrawer} onClick={drawer}></div>
      </Transition>
      <div className="va-rodape-direitos">
        <span className="va-rodape-versao">{VERSION}</span>
        <span>© 2026 App4All Tecnologia da Informação LTDA. - CNPJ: 28.902.374/0001-11</span>
      </div>
    </div>
  );

  const getNaoAutenticado = () => (
    <div style={styles.normalize}>
      <div>
        <Menu fixed='top' className="menu-horizontal" secondary style={styles.menu}>
          <Menu.Item position="left">
            <a href="https://www.voteassembleia.com.br">
              <span className="va-marca">
                <img src="/images/logo-voteassembleia-sem-escrita.png" alt="Vote Assembleia logo" className="va-marca-simbolo" />
                <span className="va-marca-nome"><b>VOTE</b>ASSEMBLEIA</span>
              </span>
            </a>
          </Menu.Item>
          <Responsive as={Menu.Menu} minWidth={768} position='right' style={styles.menumenu}>
            <Menu.Item name="ajuda">
              <Link id="ajuda" to="/ajuda" className="menu-link menu-item">
                <Icon name="help circle" /> Ajuda
              </Link>
            </Menu.Item>
            <Menu.Item name="fale-conosco">
              <Link id="fale-conosco" to="/fale-conosco" className="menu-link menu-item">
                <Icon name="envelope" /> Fale Conosco
              </Link>
            </Menu.Item>
            <Menu.Item name="cadastro">
              <Link id="cadastro" to="/cadastro" className="menu-link menu-item">
                <Icon name="building" /> Cadastre-se
              </Link>
            </Menu.Item>
            <Menu.Item name="login">
              <Link id="login" to="/login" className="menu-link menu-item">
                <Icon name="sign-in" /> Entrar
              </Link>
            </Menu.Item>
          </Responsive>
          <Responsive as={Menu.Menu} maxWidth={767} position='right' style={styles.menumenu}>
            <Menu.Item className="menu-item">
              <span className="menu-link-icone" onClick={drawer}>
                <Icon name={visible ? "close" : "bars"} size="large" />
              </span>
            </Menu.Item>
          </Responsive>
        </Menu>
        <Transition duration={{ show: 400, hide: 250 }} animation="fade left" size='huge' visible={visible}>
          <div style={styles.drawer}>
            <div>
              <Link id="ajuda" to="/ajuda" className="menu-link menu-link-drawer">
                <Icon name="help circle" /> Ajuda
              </Link>
            </div>
            <div>
              <Link id="fale-conosco" to="/fale-conosco" className="menu-link menu-link-drawer">
                <Icon name="envelope" /> Fale Conosco
              </Link>
            </div>
            <div>
              <Link id="cadastro" to="/cadastro" className="menu-link menu-link-drawer">
                <Icon name="building" /> Cadastre-se
              </Link>
            </div>
            <div>
              <Link id="login" to="/login" className="menu-link menu-link-drawer">
                <Icon name="sign-in" /> Entrar
              </Link>
            </div>
          </div>
        </Transition>
      </div>
      <Transition duration={{ show: 300, hide: 200 }} animation="fade" size='huge' visible={visible}>
        <div style={styles.bgDrawer} onClick={drawer}/>
      </Transition>
    </div>
  );

  return !!token ? getAutenticado() : getNaoAutenticado();
};

const styles = {
  menu: {
    boxShadow: "0px 1px 4px #AAA",
    backgroundColor: "rgba(255,255,255,1)",
    zIndex: "1000",
    height: "64px"
  },
  menumenu: {
    marginRight: "10px"
  },
  normalize: {
    paddingBottom: "65px"
  },
  drawer: {
    position: "fixed",
    width: "85%",
    right: "0px",
    top: "64px",
    zIndex: 1001,
    backgroundColor: "#EEE",
    height: "100%",
    overflowY: "auto",
    paddingBottom: "60px"
  },
  bgDrawer: {
    position: "fixed",
    backgroundColor: "rgba(0,0,0,.8)",
    width: "100%",
    right: "0px",
    top: "64px",
    zIndex: 1000,
    height: "100%"
  },
  itemMenuInfo: {
    padding: "30px 10px"
  },
  tituloLogo: {
    paddingLeft: "10px",
    paddingTop: "2px",
    fontWeight: "900",
    maxWidth: "200px",
    lineHeight: "1.2",
    maxHeight: "42px",
    marginTop: "1px",
    display: "inline-block",
    overflow: "hidden"
  },
  logotipo: {
    display: 'inline-block',
    maxHeight: 50,
    marginLeft: 10
  }
};

export default MenuHorizontal;
